import { render, staticRenderFns } from "./SelectBuyWay.vue?vue&type=template&id=5a8450ae&scoped=true&"
import script from "./SelectBuyWay.vue?vue&type=script&lang=js&"
export * from "./SelectBuyWay.vue?vue&type=script&lang=js&"
import style0 from "./SelectBuyWay.vue?vue&type=style&index=0&id=5a8450ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8450ae",
  null
  
)

export default component.exports